module.exports = __webpack_public_path__ + "static/slide3-92246abf00438394c31f60a4133d395b.webp";